@switch (layout$ | async) {
  @case (Layouts.Login) {
    <app-login-layout></app-login-layout>
  }
  @case (Layouts.Signup) {
    <app-signup-layout></app-signup-layout>
  }
  @case (Layouts.MobileEmulator) {
    <app-mobile-emulator-layout></app-mobile-emulator-layout>
  }
  @default {
    <app-layout [routerOutlet]="routerOutlet"></app-layout>
  }
}

<ng-template #routerOutlet>
  <router-outlet></router-outlet>
</ng-template>

<app-toast aria-atomic="true"></app-toast>

<app-tooltip-component [zIndex]="zIndexGlobalTooltip"></app-tooltip-component>
<ds-tooltip [zIndex]="zIndexGlobalTooltip"></ds-tooltip>

<app-svg-image-filters></app-svg-image-filters>
<app-svg-images></app-svg-images>
<app-svg-icons></app-svg-icons>
<app-eap-icons></app-eap-icons>

<app-feature-flag-initialized></app-feature-flag-initialized>
